import * as Yup from 'yup'
import { MotivoCancelamentoAtendimentoType } from '../../../../../_metronic/helpers'

const CPF_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
const CNS_REGEX = /^\d{3}\s?\d{4}\s?\d{4}\s?\d{4}$/

// Cancelar não é consentir: este fluxo não pede aceite do termo (ver ona-c5, AC7).
export const cancelarSchema = Yup.object().shape({
  numeroDocumento: Yup.string()
    .required('O campo CPF/CNS é obrigatório')
    .test('cpf-cns-valido', 'CPF ou CNS inválido', (value) => {
      if (!value) return false
      const digits = value.replace(/\D/g, '')
      if (digits.length === 11) return CPF_REGEX.test(value)
      if (digits.length === 15) return CNS_REGEX.test(value)
      return false
    }),
  motivo: Yup.object().nullable().required('O campo motivo do cancelamento é obrigatório'),
  motivoDetalhado: Yup.string()
    .trim()
    .when('motivo', {
      is: (motivo: { value?: string } | null) =>
        motivo?.value === MotivoCancelamentoAtendimentoType.Outros,
      then: (schema) => schema.required('O campo detalhamento do motivo é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),
})
